module.exports = __webpack_public_path__ + "static/media/f_hairstyle_tightcurls_medium_front_vector.ed59b09c.svg";